<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,8C15,7.68,14.84,7.41,14.62,7.23C14.62,7.23,14.63,7.22,14.63,7.22C14.63,7.22,9.629999999999999,3.22,9.629999999999999,3.22C9.629999999999999,3.22,9.620000000000001,3.23,9.620000000000001,3.23C9.440000000000001,3.09,9.24,3,9,3C8.45,3,8,3.45,8,4C8,4,8,6.720000000000001,8,6.720000000000001C8,6.720000000000001,3.62,3.22,3.62,3.22C3.62,3.22,3.62,3.23,3.62,3.23C3.44,3.09,3.24,3,3,3C2.45,3,2,3.45,2,4C2,4,2,12,2,12C2,12.55,2.45,13,3,13C3.24,13,3.44,12.91,3.62,12.77C3.62,12.77,3.63,12.78,3.63,12.78C3.63,12.78,8,9.280000000000001,8,9.280000000000001C8,9.280000000000001,8,12,8,12C8,12.55,8.45,13,9,13C9.24,13,9.440000000000001,12.91,9.620000000000001,12.77C9.620000000000001,12.77,9.629999999999999,12.78,9.629999999999999,12.78C9.629999999999999,12.78,14.63,8.780000000000001,14.63,8.780000000000001C14.63,8.780000000000001,14.62,8.77,14.62,8.77C14.84,8.59,15,8.32,15,8C15,8,15,8,15,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FastForward',
} as DefineComponent
</script>
